import React from 'react';

import { type Names, loadTPCForFilters } from 'common/actions/tpcForFilters';
import asyncConnect from 'common/core/asyncConnect';
import cloneElementWithProps from 'common/core/cloneElementWithProps';

import type { TPCForFiltersState } from 'common/reducers/tpcForFilters';
import type { AsyncItem } from 'redux-connect';

const asyncFetch: AsyncItem = {
  key: 'asyncTPCFetch',
  promise: ({ store: { dispatch }, location }: PromiseOptions) => {
    const { query } = location;
    const currentCompaniesQuery =
      typeof query.companies === 'string' ? query.companies.split('_') : [];

    return dispatch(loadTPCForFilters(currentCompaniesQuery));
  },
};

type TPCForFiltersContextType = {
  companies: Names;
  companiesLoading: boolean;
  error?: string;
};

export const TPCForFiltersContext = React.createContext<TPCForFiltersContextType>({
  companies: {},
  companiesLoading: false,
  error: undefined,
});

type Props = {
  children: React.ReactNode;
  tpcForFilters: TPCForFiltersState;
  companiesLoading: boolean;
};

const TPCForFiltersContainer = ({ children, tpcForFilters, companiesLoading, ...other }: Props) => {
  const loadedSuccessfully = tpcForFilters && !tpcForFilters.error;

  const value = {
    companies: loadedSuccessfully ? tpcForFilters.companyNames : {},
    companiesLoading: tpcForFilters.loading ?? false,
    error: undefined,
  };

  const clonedElement = cloneElementWithProps(children, {
    ...other,
    ...value,
  });

  return (
    <TPCForFiltersContext.Provider value={value}>{clonedElement}</TPCForFiltersContext.Provider>
  );
};

export default asyncConnect([asyncFetch], (state) => ({
  tpcForFilters: state.tpcForFilters,
}))(TPCForFiltersContainer);
